import Header from 'modules/header/farm/main';
import Description from './description';
import {Form, Formik} from 'formik';
import {initialValues} from './utilities/initialValues';
import {schema} from './utilities/validationSchema';
import {useFarm} from 'context/farmContext';
import {formDataCreator} from '../../utilities/formDataCreatot';
import usePostAd from '../../hooks/usePostAd';
import SaleFormComponent from 'components/forms/sale';
import useSetAnswers from '../simple/hooks/useSetAnswers';
import {useState} from 'react';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {FarmEvents} from 'utilities/helper/googleAnalitics/EventHelper';

const SaleForm = () => {
  const {farm} = useFarm();
  const {isLoading, mutate} = usePostAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title=" ثبت آگهی حراجی " />
      <Description />
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, farm);
          payload.append('price', values.price);
          payload.append('min_price', values.min_price);
          payload.append('duration', values.duration);
          payload.append('duration_unit', values.duration_unit);
          payload.append('decline_rate', values.decline_rate);
          payload.append('rate_unit', values.rate_unit);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
          googleAnalyticsInstance.eventGoogleAnalytics(FarmEvents.addedSale);
        }}
      >
        {({values}) => (
          <Form className="px-3 pb-4">
            <SaleFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={farm?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SaleForm;
